import {
  Div, Input, Panel, PanelHeader, PanelHeaderBack
} from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import {
  ChangeEvent,
  memo, useCallback, useEffect, useRef, useState
} from 'react';
import { AppPanelsT } from 'src/app/providers/RouteProvider/lib/routeConfig';
import { $prevActivePanel, setActivePanel } from 'src/entity/ActivePanel';
import { $isStandAlone } from 'src/entity/User';
import { $isImageCropped, CropImage } from 'src/features/cropImage';
import { SavePostCard } from 'src/features/savePostCard';
import { UploadImage } from 'src/features/uploadImage';
import krs from 'src/shared/assets/images/krs.png';
import logo from 'src/shared/assets/images/logo.png';
import { Cover } from 'src/shared/ui/cover';
import { Title, TitleSize } from 'src/shared/ui/title/Title';

import bridge from '@vkontakte/vk-bridge';

import cls from './PostCard.module.scss';
import { UserInitials } from './UserInitials/UserInitials';

interface IPostCardPanelProps {
  id: AppPanelsT;
}

export const PostCardPanel = memo(({ id }: IPostCardPanelProps) => {
  const [
    isImageCropped,
    onSetActivePanel,
    prevActivePanel,
    isStandAlone
  ] = useUnit([
    $isImageCropped,
    setActivePanel,
    $prevActivePanel,
    $isStandAlone
  ]);

  const [isShowNameInput, setIsShowNameInput] = useState<boolean>(false);
  const [isShowLastnameInput, setIsShowLastnameInput] = useState<boolean>(false);
  const [isShowName, setIsShowName] = useState<boolean>(true);
  const [isShowLastname, setIsShowLastname] = useState<boolean>(true);
  const [name, setName] = useState<string>('ИМЯ');
  const [lastname, setLastname] = useState<string>('ФАМИЛИЯ');

  const onNameClick = useCallback(() => {
    // @ts-ignore
    bridge.send('VKWebAppSendCustomEvent', {
      event: 'accreditation_name_click'
    });

    setIsShowName(false);
    setName('');
    setIsShowNameInput(true);
  }, []);

  const onNameInputChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setName(e.currentTarget.value);
  }, []);

  const onNameInputBlur = useCallback(() => {
    if (!name.length) {
      setName('ИМЯ');
    }
    setIsShowName(true);
    setIsShowNameInput(false);
  }, [name]);

  const onLastnameClick = useCallback(() => {
    // @ts-ignore
    bridge.send('VKWebAppSendCustomEvent', {
      event: 'accreditation_surname_click'
    });

    setIsShowLastname(false);
    setLastname('');
    setIsShowLastnameInput(true);
  }, []);

  const onLastnameInputChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setLastname(e.currentTarget.value);
  }, []);

  const onBackClick = useCallback(() => {
    if (!prevActivePanel) return;

    onSetActivePanel(prevActivePanel);
  }, [onSetActivePanel, prevActivePanel]);

  const onLastnameInputBlur = useCallback(() => {
    if (!lastname.length) {
      setLastname('ФАМИЛИЯ');
    }
    setIsShowLastname(true);
    setIsShowLastnameInput(false);
  }, [lastname]);

  const postCardPanelRef = useRef<HTMLDivElement>(null);
  const [savingElement, setSavingElement] = useState<HTMLDivElement | null>(
    null
  );

  useEffect(() => {
    setSavingElement(postCardPanelRef.current);
  }, []);

  return (
    <Panel
      id={id}
    >
      <PanelHeader
        transparent
        visor={false}
        separator={false}
        style={{ width: '0px' }}
        before={(
          <PanelHeaderBack
            onClick={onBackClick}
          />
        )}
      />
      <div
        ref={postCardPanelRef}
      >
        <Div
          className={cls.postCardWrapper}
        >
          <Div className={cls.header}>
            <img className={cls.img} src={krs} alt='krs' />
            <img className={cls.img} src={logo} alt='Главные Герои 2024' />
          </Div>

          <Div className={cls.content}>
            <Div>
              <Title
                align='center'
                size={TitleSize.L}
              >
                ЖЮРИ
              </Title>
            </Div>

            <Div className={cls.photo}>
              <UploadImage />
              <CropImage />
            </Div>

            <Div className={cls.signature}>
              {isShowName && (
                <UserInitials
                  onClick={onNameClick}
                  text={name}
                />
              )}
              {isShowNameInput && (
                <Input
                  autoFocus
                  onBlur={onNameInputBlur}
                  onChange={onNameInputChange}
                  value={name}
                />
              )}
              {isShowLastname && (
                <UserInitials
                  onClick={onLastnameClick}
                  text={lastname}
                />
              )}
              {isShowLastnameInput && (
                <Input
                  autoFocus
                  onBlur={onLastnameInputBlur}
                  onChange={onLastnameInputChange}
                  value={lastname}
                />
              )}
            </Div>
          </Div>
        </Div>
        <Cover />
      </div>

      {isImageCropped && <SavePostCard savingElement={savingElement} />}
      {/* Раскоментить как починю */}
      {/* {(isImageCropped && !isStandAlone) && <SharePostCardToVk savingElement={savingElement} />} */}
    </Panel>
  );
});
